import type { EnvironmentId } from "@t3tools/contracts";
import { FolderIcon } from "lucide-react";
import { useState } from "react";
import { resolveEnvironmentHttpUrl } from "../environments/runtime";
import { useServerObjectUrl } from "../lib/serverObjectUrl";

export function ProjectFavicon(input: {
  environmentId: EnvironmentId;
  cwd: string;
  className?: string;
}) {
  const src = (() => {
    try {
      return resolveEnvironmentHttpUrl({
        environmentId: input.environmentId,
        pathname: "/api/project-favicon",
        searchParams: { cwd: input.cwd },
      });
    } catch {
      return null;
    }
  })();
  const objectUrl = useServerObjectUrl(src);
  const [undecodable, setUndecodable] = useState<string | null>(null);

  if (!objectUrl || undecodable === objectUrl) {
    return (
      <FolderIcon
        className={`size-3.5 shrink-0 text-muted-foreground/50 ${input.className ?? ""}`}
      />
    );
  }

  return (
    <img
      src={objectUrl}
      alt=""
      className={`size-3.5 shrink-0 rounded-sm object-contain ${input.className ?? ""}`}
      onError={() => setUndecodable(objectUrl)}
    />
  );
}
